import { commonEventLogger, makeProductEventLogger } from "@saflib/vue";
import type { ProductEvent } from "@vendata/power-up-spec";
import type { Part, PartTrace } from "@vendata/power-up-spec";

export const eventLogger = makeProductEventLogger<ProductEvent>();
eventLogger.onProductEvent(commonEventLogger<ProductEvent>);

export const traceFromPart = (part: Part): PartTrace => {
  return {
    manufacturer: part.manufacturer,
    turbine_model: part.turbine_model || "",
    frame: part.frame || "",
    casting_number: part.casting_number || "",
    part_number: part.part_number || "",
    part_id: part.id,
  };
};
